<template>
  <div class="slider">
    <VueSlider
      v-model="value"
      :disabled="validate || locked"
      :min="slider.min"
      :max="slider.max"
      :contained="true"
      :process="false"
      :class="validatedClasses"
      class="answer-slider"
      dot-size="50"
      drag-on-click
      tooltip="none"
      @change="onChange"
    >
      <template v-slot:dot>
        <div class="handle" :class="{ locked: locked }">
          {{ value }}
        </div>
      </template>
    </VueSlider>
    <transition name="fade" @enter="showInfoButton = true">
      <VueSlider
        v-if="validate"
        v-model="slider.correct"
        :min="slider.min"
        :max="slider.max"
        :process="false"
        :contained="true"
        class="correct-answer"
        :class="validatedClasses"
        dot-size="50"
        disabled
      >
        <template v-slot:dot>
          <div class="handle">
            {{ slider.correct }}
            <transition name="bounce">
              <InfoButton
                v-if="showInfoButton && hasFacts"
                class="info-button"
                @click="onInfoClick"
              />
            </transition>
          </div>
        </template>
      </VueSlider>
    </transition>

    <div class="description" :class="{ nodescription: nodescription }">
      Drag i reglaget för att justera
    </div>
  </div>
</template>

<script>
import InfoButton from '@/components/InfoButton';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
  components: {
    InfoButton,
    VueSlider
  },
  props: {
    hasFacts: { type: Boolean, default: () => false },
    locked: { type: Boolean, default: () => false },
    slider: { type: Object, default: () => {} },
    validate: { type: Boolean, default: () => false },
    nodescription: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      value: this.slider.min,
      interacted: false,
      showInfoButton: false
    };
  },
  computed: {
    validatedClasses() {
      let c = [];

      if (this.validate) {
        c.push('validate');
      }
      if (this.interacted) {
        c.push('interacted');
      }

      if (this.value === this.slider.correct) {
        c.push('correct');
      } else {
        c.push('wrong');
      }
      return c;
    }
  },
  watch: {
    validate(newValidateValue) {
      if (newValidateValue === true) {
        const questionScore = this.value === this.slider.correct ? 1 : 0;
        this.$emit('score-changed', questionScore);
      }
    }
  },
  methods: {
    onChange() {
      if (!this.interacted) {
        this.interacted = true;
      }
      this.$emit('change', this.value);
    },
    onInfoClick() {
      this.$emit('info');
    }
  }
};
</script>

<style lang="scss">
.slider {
  position: relative;

  .description {
    margin-top: 40px;
    font-weight: 300;
    font-size: 14px;
    line-height: 110%;
    text-align: center;

    color: #303030;
    &.nodescription {
      display: none;
    }
  }

  .vue-slider {
    .handle {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;

      font-family: 'HelveticaNeue', sans-serif;
      font-size: 14px;
      line-height: 110%;
      font-weight: 700;

      background: #ffffff;
      border: 1px solid #c4c4c4;
      box-sizing: border-box;
      border-radius: 25px;

      transition: color 0.2s, background 0.2s, opacity 0.2s linear 0.5s;

      &.locked {
        cursor: not-allowed;
      }
    }

    &.vue-slider-disabled {
      opacity: 1;
      cursor: default;
    }

    &.answer-slider {
      &.interacted {
        .handle {
          color: #fff;
          border: 0;
          background: #303030;
        }
      }
      &.validate {
        &.wrong {
          .handle {
            opacity: 0.2;
            color: #fff;
            background: #aa112c;
            border: 0;
          }
        }
        &.correct {
          .handle {
            color: #fff;
            background: #2ca386;
            border: 0;
          }
        }
      }
      .vue-slider-rail {
        background: #ededed;
        border-radius: 2px;
      }
    }

    &.correct-answer {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      .validate {
        transition-delay: 0.5s;
      }

      .handle {
        color: #fff;
        background: #2ca386;
        border: 0;
      }
      .vue-slider-rail {
        background: transparent;
        border-radius: 2px;
      }
    }
  }
  .info-button {
    position: absolute;
    top: -38px;
    left: 20px;
    z-index: 1;
  }
}
</style>
